import { ENDPOINTS } from 'config/endpoints';
import { useQuery } from '@tanstack/react-query';
import CronoError from 'crono-fe-common/types/error';
import client from 'utils/clients/client';
import { Request } from 'crono-fe-common/types/request';
import { ResponsePaginated } from 'crono-fe-common/types/response';
import {
  ExternalProperty,
  TableType,
} from 'crono-fe-common/types/externalProperty';

interface IProps {
  tableType: TableType | null;
  onlyTag?: boolean | null;
  onlyInsert?: boolean | null;
  withLead?: boolean | null;
  withUser?: boolean | null;
  enabled?: boolean;
  isFilter?: boolean;
  onlyAiVariables?: boolean;
  refetchOnMount?: boolean | 'always';
}

export default function useGetExternalProperty({
  tableType,
  onlyTag,
  onlyInsert,
  withLead,
  withUser,
  enabled = true,
  isFilter,
  onlyAiVariables,
  refetchOnMount,
}: IProps) {
  const params: {
    TableType?: string;
    OnlyTag?: string;
    OnlyInsert?: string;
    WithLead?: string;
    WithUser?: string;
    isFilter?: string;
    onlyAiVariables?: string;
  } = {};

  if (tableType) {
    params['TableType'] = tableType;
  }
  if (onlyTag) {
    params['OnlyTag'] = String(onlyTag);
  }
  if (onlyInsert) {
    params['OnlyInsert'] = String(onlyInsert);
  }
  if (withLead) {
    params['WithLead'] = String(withLead);
  }
  if (withUser) {
    params['WithUser'] = String(withUser);
  }
  if (isFilter) {
    params['isFilter'] = String(isFilter);
  }
  if (onlyAiVariables) {
    params['onlyAiVariables'] = String(onlyAiVariables);
  }
  const queryString = new URLSearchParams(params).toString();

  const request: Request = {
    url: ENDPOINTS.externalProperty.main + '?' + queryString,
    config: {
      method: 'get',
    },
  };

  const requestConfig = {
    queryKey: [ENDPOINTS.externalProperty.main, queryString],

    queryFn: () => client(request),
    enabled,
    staleTime: 60 * 60 * 1000,
    refetchOnMount,
    refetchOnWindowFocus: false,
  };

  const { data, ...rest } = useQuery<
    ResponsePaginated<ExternalProperty[]>,
    CronoError
  >(requestConfig);

  return { data, ...rest };
}
